import type { RGB } from "./rgb-color";

const calculateHueFromRgb = (
    rgb: RGB,
    options?: {
        min?: number;
        max?: number;
        delta?: number;
    }
): number => {
    const { red, green, blue } = rgb;
    const min = options?.min || Math.min(red, green, blue);
    const max = options?.max || Math.max(red, green, blue);
    const delta = options?.delta || max - min;

    if (min === max) return 0;

    switch (max) {
        case red:
            return (
                (((green - blue) / delta + (green < blue ? 6 : 0)) / 6) * 360
            );
        case green:
            return (((blue - red) / delta + 2) / 6) * 360;
        case blue:
            return (((red - green) / delta + 4) / 6) * 360;
    }

    throw new Error("Hue could not be calculated"); // should be impossible if code above is correct;
};

export { calculateHueFromRgb };
